import Link from "../../components/router-link";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../../components/motion";
import { SolutionAdvisor } from "../../components/solution-advisor";
import { SolutionTabs } from "../../components/solution-tabs";
import { CTA, PageHero, SectionHeading } from "../../components/site-shell";
import { solutionCards } from "../../lib/site-data";
import { createMetadata } from "../../lib/seo";
import { solutionLandingPages } from "../../lib/landing-pages";

export const metadata = createMetadata({
  title: "品牌增长与产品出海方案",
  description:
    "面向国内品牌、出海企业、制造企业和外贸企业，提供品牌增长、企业官网、海外独立站、多语言内容、SEO、GEO、AI 搜索与海外询盘解决方案。",
  path: "/solutions",
  keywords: [
    "品牌增长解决方案",
    "产品出海解决方案",
    "企业出海服务",
    "海外独立站建设",
    "外贸独立站",
    "制造业出海",
    "Google SEO",
    "海外SEO优化",
    "GEO优化解决方案",
    "企业GEO优化",
    "海外GEO优化",
    "生成式引擎优化",
    "AI搜索优化",
    "AI搜索可见性",
    "海外询盘增长",
  ],
  image: "/assets/office.jpg",
});

export default function SolutionsPage() {
  return (
    <div className="section-dark">
      <PageHero
        eyebrow="品牌增长 · 产品出海"
        title="企业品牌增长与产品出海解决方案"
        description="不是把品牌、网站、内容和搜索简单拼在一起，而是根据目标市场与现有基础，先解决最影响客户理解和询盘的断点。"
        image="/assets/office.jpg"
      />
      <section className="section-shell section-block-sm">
        <SolutionTabs items={solutionCards} />
        <nav
          className="seo-related-links seo-index-links"
          aria-label="解决方案详情"
        >
          {solutionLandingPages.map((page) => (
            <Link href={page.path} key={page.path}>
              <span>
                <strong>{page.pageTitle}</strong>
                <small>{page.description}</small>
              </span>
              <ArrowUpRight size={18} aria-hidden="true" />
            </Link>
          ))}
        </nav>
      </section>
      <section className="section-shell section-block-sm">
        <Reveal>
          <SectionHeading
            eyebrow="方案选择"
            title="先识别增长断点，再确定适合当前阶段的路径。"
            description="从业务目标、目标市场和现有基础出发，判断应优先建设品牌、官网、内容、搜索还是线索承接能力。"
          />
        </Reveal>
        <SolutionAdvisor />
      </section>
      <CTA title="从一个清晰的增长起点，走向可持续的客户增长。" />
    </div>
  );
}
